export async function downloadGuideHistoryUseCase(client_id, initial_date, final_date, guideRepostitory) {
    const result = await guideRepostitory.donwload_history_report(client_id, initial_date, final_date);

    return result;
}